"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoBubble = void 0;
const react_1 = __importStar(require("react"));
const react_2 = require("react");
const HostBubble_1 = require("../HostBubble");
const react_youtube_1 = __importDefault(require("react-youtube"));
const messages_1 = require("../../../services/messages");
const VideoBubble = ({ message, onTypingEnd, }) => {
    const [typing, setTyping] = (0, react_1.useState)(true);
    (0, react_2.useEffect)(() => {
        const isFromProvider = message.params;
        if (isFromProvider)
            return;
        setTimeout(() => {
            setTyping(false);
            onTypingEnd();
        }, HostBubble_1.defaultTypeSpeed.medium);
    }, []);
    const onLoaded = () => {
        setTyping(false);
        onTypingEnd();
    };
    const params = message.params;
    if (params) {
        return (react_1.default.createElement(VideoFromProvider, { params: params, typing: typing, onLoaded: onLoaded }));
    }
    return react_1.default.createElement(VideoWithUrl, { url: message.content, typing: typing });
};
exports.VideoBubble = VideoBubble;
const VideoFromProvider = ({ params, typing, onLoaded, }) => {
    const { provider, id } = params;
    return provider === "youtube" ? (react_1.default.createElement("div", { className: "w-full p-4 content-opacity z-10 " +
            (typing ? "opacity-0" : "opacity-100") },
        react_1.default.createElement(react_youtube_1.default, { videoId: id, opts: { height: typing ? "2rem" : "315px" }, className: "w-full rounded-md", onReady: onLoaded, onPlay: messages_1.sendVideoPlayedMessage }))) : (react_1.default.createElement("iframe", { src: `https://player.vimeo.com/video/${id}`, className: "w-full p-4 content-opacity z-10 " +
            (typing ? "opacity-0" : "opacity-100"), height: typing ? "2rem" : "315px", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture", allowFullScreen: true, onLoad: onLoaded }));
};
const VideoWithUrl = ({ url, typing }) => {
    const isSafariBrowser = window.navigator.vendor.match(/apple/i);
    return (react_1.default.createElement("video", { controls: true, className: "p-4 focus:outline-none w-full z-10 content-opacity " +
            (typing ? "opacity-0" : "opacity-100"), style: {
            height: typing ? "2rem" : "auto",
            maxHeight: isSafariBrowser ? "40vh" : "",
        }, autoPlay: true, onPlay: messages_1.sendVideoPlayedMessage },
        react_1.default.createElement("source", { src: url, type: "video/mp4" }),
        "Sorry, your browser doesn't support embedded videos."));
};
//# sourceMappingURL=VideoBubble.js.map